import type { GetRequestsListItem } from "@nlc/shared-types";

import { whitelabelRowClassName } from "@/features/requests/constants/accountTags";

import type { TableConfig } from "../../../types/tables";

import { TABLE_LAYOUT_PRESETS } from "../../constants/columnWidths";
import { accountTagsCell } from "../../helpers/accountTagsCell";
import {
  inlineAssigneeCell,
  inlineBrandCell,
  inlineComplexityCell,
  inlineStatusCell,
} from "../../helpers/cellRenderers";
import {
  accountCellWithSlotTooltip,
  designTypeCell,
  nameCell,
} from "../../helpers/commonCells";

// Due Today Tab Configuration for Team Lead "Assigned to Me"
// Columns: Name, Account, Brand, Assignee, Status, Created by, Created date, Request/Design type, Tags
export const teamleadDueTodayTableConfig: TableConfig<GetRequestsListItem> = {
  columns: [
    {
      accessor: "name",
      cellRenderer: nameCell,
      header: "Name",
      key: "name",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.name,
    },
    {
      accessor: "account",
      cellRenderer: accountCellWithSlotTooltip,
      header: "Account",
      key: "account",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.account,
    },
    {
      accessor: "assignee",
      cellRenderer: inlineAssigneeCell,
      header: "Assignee",
      key: "assignee",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.assignee,
    },
    {
      accessor: "status",
      cellRenderer: inlineStatusCell,
      header: "Status",
      key: "status",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.status,
    },
    {
      accessor: "complexity",
      cellRenderer: inlineComplexityCell,
      header: "Level",
      key: "complexity",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.complexity,
    },
    {
      accessor: "brand",
      cellRenderer: inlineBrandCell,
      header: "Brand",
      key: "brand",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.brand,
    },
    {
      accessor: "designType",
      cellRenderer: designTypeCell,
      header: "Design Type",
      key: "designType",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.requestType,
    },
    {
      accessor: "account",
      cellRenderer: accountTagsCell,
      header: "Tags",
      key: "accountTags",
      sortable: false,
      width: 150,
    },
  ],
  defaultSort: {
    column: "dueDate",
    direction: "asc",
  },
  enableSorting: true,
  getRowClassName: whitelabelRowClassName,
  id: "teamlead-due-today-requests",
  title: "Due Today Requests",
};
